import Axios, { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import { ReadResponse } from '../dto/response/ReadResponse';
import { BankIncomingTxnSearch } from '../dto/bank/BankIncomingTxnSearch';
import { ApiClient } from '../util/ApiUtility';

export const onBankTxnSearch = async (data: BankIncomingTxnSearch) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/wallet/bank-incoming-txn/search',
        params: {
            senderAccountNo: data.senderAccountNo,
            offset: data.offset,
            limit: data.limit
        }
    }
    const response = await ApiClient().request<ReadResponse>(requestConfig);
    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}